export default .05
